import equal from 'fast-deep-equal';

export const isCurrentRefinementItemsChanged = (prevItems, nextItems) =>
    nextItems.some(item => {
        const foundItem = prevItems.find(({ id }) => item.id === id);
        return (
            !foundItem ||
            (Array.isArray(foundItem.currentRefinement) &&
            Array.isArray(item.currentRefinement)
                ? !equal(
                      foundItem.currentRefinement.sort(),
                      item.currentRefinement.sort(),
                  )
                : !equal(foundItem.currentRefinement, item.currentRefinement))
        );
    }) || prevItems.length !== nextItems.length;

export default {
    isCurrentRefinementItemsChanged,
};
